import type { Nullish } from "@ca/types/util";

import { locale } from "./local";

export const formatDegrees = (degrees: Nullish<number>, decimalPlaces = 2) => {
	if (degrees === null || degrees === undefined) {
		return "--";
	}

	return Intl.NumberFormat(locale, {
		maximumFractionDigits: decimalPlaces,
		style: "unit",
		unit: "degree",
		unitDisplay: "short",
	}).format(degrees);
};
